"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CacheHolder {
}
CacheHolder.cache = null;
CacheHolder.setCache = (cache) => {
    CacheHolder.cache = cache;
};
CacheHolder.getCache = () => {
    return CacheHolder.cache;
};
exports.default = CacheHolder;
//# sourceMappingURL=CacheHolder.js.map